import { gql } from '@apollo/client';

import {
  PersistedQueryListQuery,
  PersistedQueryListQueryVariables,
} from 'src/lib/graphqlTypes/types';

export const persistedQueryListQuery = gql<
  PersistedQueryListQuery,
  PersistedQueryListQueryVariables
>`
  query PersistedQueryListQuery(
    $graphId: ID!
    $listId: ID!
    $first: Int
    $last: Int
    $before: String
    $after: String
    $filter: PersistedQueryFilterInput
    $sort: PersistedQuerySortInput
    $clientNamesFirst: Int
  ) {
    graph(id: $graphId) {
      id
      title
      persistedQueryList(id: $listId) {
        id
        name
        clientNames(first: $clientNamesFirst) {
          edges {
            node
          }
        }
        currentBuild {
          id
          totalOperationsInList
        }
        linkedVariants {
          id
          name
        }
        operations(
          first: $first
          last: $last
          before: $before
          after: $after
          filter: $filter
          sort: $sort
        ) {
          pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
          }
          totalCount
          edges {
            node {
              id
              clientName
              name
              body
              firstPublishedAt
              lastPublishedAt
            }
            cursor
          }
        }
      }
    }
  }
`;
